import { PropertyFilterProps, SelectProps } from '@amzn/awsui-components-react';
import { getString } from 'common/ui-string-labels/ui-strings-utils';
import { useFlashBarItemsActions } from 'common/UseFlashBarItems/useFlashBarItems';
import { VENDORS } from 'configuration/config';

export interface ResellerReport {
    taxonomyId: string;
    vendor: string;
    amazonPo: string;
    sentTo: string;
    orderCount: number;
    totalCost: number;
    sentDay: string;
    status: 'SENT' | 'FAILED';
    sentBy: string;
}

export interface ResellerReportHistoryTableProps {
    useFlashBarItemsActions: useFlashBarItemsActions;
}

export interface GetResellerReportsParams {
    vendor?: string;
    status?: string;
    search?: string;
    amazonPo?: string;
    dateFrom?: string;
    dateTo?: string;
    limit: number;
    nextToken?: string;
}

export const VENDOR_OPTIONS: SelectProps.Options = [
    { value: '', label: getString('resellerReportHistory.filter.allVendors') },
    ...VENDORS.map(v => ({ value: v.id, label: v.label })),
];

export const STATUS_OPTIONS: SelectProps.Options = [
    { value: '', label: getString('resellerReportHistory.filter.allStatuses') },
    { value: 'SENT', label: getString('resellerReportHistory.filter.sent') },
    { value: 'FAILED', label: getString('resellerReportHistory.filter.failed') },
];

export const FILTERING_PROPERTIES: PropertyFilterProps.FilteringProperty[] = [
    { key: 'amazonPo', propertyLabel: getString('resellerReportHistory.filter.amazonPoLabel'), groupValuesLabel: getString('resellerReportHistory.filter.amazonPoGroupValues'), operators: ['='] },
];
